<template>
  <footer class="bg-[#0F172A] text-[#94A3B8]">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
      <div class="grid gap-10 sm:grid-cols-2 lg:grid-cols-12">

        <!-- Marque -->
        <div class="lg:col-span-4">
          <span class="text-xl font-extrabold text-white tracking-tight">
            Giraaf<span :style="gradientText">Desk</span>
          </span>
          <p class="mt-3 text-sm leading-relaxed max-w-xs">
            Le helpdesk simple pour suivre, prioriser et résoudre les demandes de vos clients.
          </p>
          <p class="mt-4 text-xs leading-relaxed">
            Un produit de l'écosystème Giraaf Park, conçu à Tunis.
          </p>
        </div>

        <!-- Produit -->
        <nav class="lg:col-span-2" aria-label="Produit">
          <h2 class="text-sm font-bold text-white">Produit</h2>
          <ul class="mt-4 space-y-2.5 text-sm">
            <li>
              <button type="button" @click="$emit('navigate', 'home')"
                class="hover:text-white transition cursor-pointer">Accueil</button>
            </li>
            <li>
              <button type="button" @click="$emit('navigate', 'home', 'fonctionnalites')"
                class="hover:text-white transition cursor-pointer">Fonctionnalités</button>
            </li>
            <li>
              <button type="button" @click="$emit('navigate', 'home', 'fonctionnement')"
                class="hover:text-white transition cursor-pointer">Comment ça marche</button>
            </li>
            <li>
              <button type="button" @click="$emit('navigate', 'app')"
                class="hover:text-white transition cursor-pointer">Ouvrir le helpdesk</button>
            </li>
          </ul>
        </nav>

        <!-- Écosystème -->
        <nav class="lg:col-span-3" aria-label="Écosystème Giraaf">
          <h2 class="text-sm font-bold text-white">Écosystème Giraaf</h2>
          <ul class="mt-4 space-y-2.5 text-sm">
            <li v-for="link in ecosystem" :key="link.label">
              <a :href="link.href" target="_blank" rel="noopener noreferrer" class="hover:text-white transition">{{
                link.label }}</a>
            </li>
          </ul>
        </nav>

        <!-- Contact -->
        <div class="lg:col-span-3">
          <h2 class="text-sm font-bold text-white">Contact</h2>
          <ul class="mt-4 space-y-2.5 text-sm">
            <li><a href="mailto:contact@giraafpark.com" class="hover:text-white transition">contact@giraafpark.com</a>
            </li>
            <li><a href="tel:+21625030813" class="hover:text-white transition">+216 25 030 813</a></li>
            <li><a href="https://giraafpark.com" target="_blank" rel="noopener noreferrer"
                class="hover:text-white transition">giraafpark.com</a></li>
          </ul>
        </div>
      </div>

      <!-- Mentions -->
      <div
        class="mt-12 pt-6 border-t border-[#1E293B] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs">
        <p>© {{ year }} STE GIRAAF PARK ACTIVITE INFORMATIQUE. Tous droits réservés.</p>
        <ul class="flex flex-wrap gap-x-5 gap-y-2">
          <!-- TODO : remplacer ces liens par les vraies pages légales quand elles existent -->
          <li v-for="link in legal" :key="link.label">
            <a :href="link.href" target="_blank" rel="noopener noreferrer" class="hover:text-white transition">{{
              link.label }}</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  emits: ['navigate'],
  data() {
    return {
      year: new Date().getFullYear(),
      gradientText: {
        background: 'linear-gradient(135deg, #38BDF8 0%, #818CF8 100%)',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        color: 'transparent'
      },
      ecosystem: [
        { label: 'GiraafChat', href: 'https://chat.giraafpark.com' },
        { label: 'GiraafProspect', href: 'https://prospect.giraafpark.com' },
        { label: 'GiraafDealflow', href: 'https://dealflow.giraafpark.com' },
        { label: 'Giraaf Park', href: 'https://giraafpark.com' }
      ],
      legal: [
        { label: 'Confidentialité', href: 'https://giraafpark.com' },
        { label: 'Conditions générales', href: 'https://giraafpark.com' },
        { label: 'Mentions légales', href: 'https://giraafpark.com' }
      ]
    }
  }
}
</script>
